import styled from "styled-components";
import AccountTransferNavbar from "../../components/Accounts/AccountTransferNavbar";
import { Hrule, LoadingSpinner, Overlay } from "../AddUserPage/AddUser";
import AccountTransfer from "../../template/AccountTransfer/FipayTransfer";
import { ReactNode, useEffect, useState } from "react";
import BankAccountTransfer from "../../template/AccountTransfer/BankAccountTransfer";
import { useLocation } from "react-router-dom";
import { getData, setLocalStorageData } from "../../utils/localStorage";
import WireTransfer from "../../template/AccountTransfer/WireTransfer";
import PayAnyOne from "../../template/AccountTransfer/PayAnyOne";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";

interface TransferConfig {
  path: string;
  component: React.ComponentType<any>;
}

const transferComponents: TransferConfig[] = [
  { path: "/dashboard/accounts/payment-details", component: AccountTransfer },
  {
    path: "/dashboard/accounts/recipient-details",
    component: BankAccountTransfer,
  },
  {
    path: "/dashboard/accounts/recipient-details-wire-transfer",
    component: WireTransfer,
  },
  {
    path: "/dashboard/accounts/recipient-details-pay-anyone",
    component: PayAnyOne,
  },
];

const FipayAccountTransfer: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState<string>("");
  const { isLoading } = useSelector((state: RootState) => state.loadingSpinner);

  const getTransferComponent = (
    path: string
  ): React.ComponentType<any> | null => {
    const config = transferComponents.find((tc) => currentPath == tc.path);
    return config ? config.component : null;
  };
  const TransferComponent = getTransferComponent(location.pathname);
  useEffect(() => {
    const paths = [
      "payment-details",
      "recipient-details",
      "recipient-details-wire-transfer",
      "recipient-details-pay-anyone",
    ];
    if (paths.includes(location.pathname.split("/")[3])) {
      setLocalStorageData("TransferType", location.pathname);
    }
    const path = getData("TransferType");
    setCurrentPath(path);
  }, [location.pathname]);
  return (
    <Wrapper>
      {isLoading && (
        <Overlay>
          <LoadingSpinner />
        </Overlay>
      )}
      <AccountTransferNavbar />
      <Hrule />
      {TransferComponent && <TransferComponent />}
      {children}
    </Wrapper>
  );
};

export default FipayAccountTransfer;
export const Wrapper = styled.div`
  height: auto;
  width: auto;
  background-color: #f7f7f7;
  padding-bottom: 2rem;
`;
